<template>
    <table class="open-positions">
        <tr class="open-positions__title-row">
            <td v-for="(title, index) in titles" :key="index"
              :class="title.class">
              {{title.title}}
              <i v-if="title.order" class="icon-arrow-down" @click="switchSorting(index)"></i> <!-- TODO: editable (clickable) icons -->
            </td>
        </tr>
        <tr class="open-positions__row" 
          v-for="(pos, index) in positionsWithCurrentFilters" 
          :key="'pos_' + index">
            <td class="open-positions__row-item-number">{{pos.id}}</td>
            <td class="open-positions__row-item-instrument">{{pos.symbol}}</td>
            <td class="open-positions__row-item-time">{{pos.timeEnter}}</td>
            <td class="open-positions__row-item-type"
                :class = "(pos.side < 0) ? 'color-red' : 'color-green'">{{(pos.side === -1) ? 'SELL' : 'BUY'}}</td>
            <td class="open-positions__row-item-volume">{{pos.volume}}</td>
            <td class="open-positions__row-item-price">{{pos.priceEnter}}</td>
            <td class="open-positions__row-item-tp">{{pos.tp}}</td>
            <td class="open-positions__row-item-sl">{{pos.sl}}</td>
            <td class="open-positions__row-item-pl-s"
                :class = "(pos.resultDepo < 0) ? 'color-red' : 'color-green'">{{pos.resultDepo}}</td>
            <td class="open-positions__row-item-pl-pip"
                :class = "(pos.resultPoint < 0) ? 'color-red' : 'color-green'">{{pos.resultPoint}}</td>
        </tr>
    </table>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            titles: [
                { title: 'Номер', class: 'open-positions__title-row-item-number', field: 'id' },
                { title: 'Инструмент', class: 'open-positions__title-row-item-instrument', field: 'symbol', order: 'asc'},
                { title: 'Время открытия', class: 'open-positions__title-row-item-time', field: 'timeEnter', order: 'asc'},
                { title: 'Тип', class: 'open-positions__title-row-item-type', field: 'side'},
                { title: 'Объём', class: 'open-positions__title-row-item-volume', field: 'volume'},
                { title: 'Цена', class: 'open-positions__title-row-item-price', field: 'priceEnter'},
                { title: 'T/P', class: 'open-positions__title-row-item-tp', field: 'tp' },
                { title: 'S/L', class: 'open-positions__title-row-item-tp', field: 'sl' },
                { title: 'P/L, $', class: 'open-positions__title-row-item-pl-s', field: 'presultDepo' },
                { title: 'P/L, P', class: 'open-positions__title-row-item-pl-pip', field: 'resultPoint' },
            ]
        };
    },
    computed:{
        ...mapGetters({
                positionsFlat: 'positions/positionsFlat',
                positionsFlatFiltered: 'positions/positionsFlatFiltered'
            }),
            positionsWithCurrentFilters() {
                return this.positionsFlatFiltered(this.filters);
        },
        filters() {
            let filtersAr = [];
            for (let i = 0; i < this.titles.length; i++) {
                let order = this.titles[i].order;
                if (!order) continue;
                filtersAr.push({
                    field: this.titles[i].field,
                    dir: order
                });
            }
            return filtersAr;
        },
        // удалить поле из объекта: delete this.titles[i]['order'];
        // в обработчике запоминать сортировку полей и сохранять
        // их в this.$store.dispatch('usersets/applyWidgetSettings', {
        /*        
                id: 'openPositionsTable',
                filters: filters
            });
        */
        // см компонент quote-table
    },
    methods:
    {
        switchSorting(index)
        {
                if (this.titles[index].order === 'asc')
                this.titles[index].order = 'desc'
                else 
                this.titles[index].order = 'asc' 
        }
    }
};
</script>

<style lang="less" scoped>
.open-positions {
  background-color: #3d536b;
  border-radius: 4px 4px 0px 0px;
  width: 100%;

  &__title-row {
    border-bottom: solid 1px #374b62;
    font-family: Arimo;
    font-size: 10px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 4;
    letter-spacing: 0.4px;
    color: #aabed2;
    text-transform: uppercase;
    text-align: left;

    &-item {
    }

    &-item-number {
      padding-left: 12px;
      width: 46px;
    }

    &-item-instrument {
      width: 73px;
      margin: 0px 4px;
    }

    &-item-time {
      width: 142px;
      margin: 0px 4px;
    }

    &-item-type {
      width: 40px;
      margin: 0px 4px;
    }

    &-item-volume {
      width: 60px;
      margin: 0px 4px;
      text-align: right;
    }

    &-item-price {
      width: 60px;
      margin: 0px 4px;
      text-align: right;
    }

    &-item-tp {
      width: 60px;
      margin: 0px 4px;
      text-align: right;
    }

    &-item-sl {
      width: 60px;
      margin: 0px 4px;
      text-align: right;
    }

    &-item-pl-s {
      width: 60px;
      margin: 0px 4px;
      text-align: right;
    }

    &-item-pl-per {
      width: 35px;
      margin: 0px 4px;
      text-align: right;
    }

    &-item-pl-pip {
      width: 35px;
      text-align: right;
      padding-right: 12px;
    }

    &-item-ico {
      width: 18px;
      margin: 0px 4px;
    }
  }

  &__row {
    border-bottom: solid 1px #374b62;
    font-family: Arimo;
    font-size: 13px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.15;
    letter-spacing: 0.4px;
    color: #ffffff;
    text-transform: uppercase;
    text-align: left;
    cursor: pointer;
    max-height: 28px;

    &:hover {
      background-color: #506b89;

      i {
        color: #cae9ff;
      }
    }

    &-item {
    }

    &-item-number {
      padding-left: 12px;
      width: 46px;
    }

    &-item-instrument {
      width: 73px;
      margin: 0px 4px;
    }

    &-item-time {
      width: 142px;
      margin: 0px 4px;
    }

    &-item-type {
      width: 40px;
      margin: 0px 4px;
    }

    &-item-volume {
      width: 60px;
      margin: 0px 4px;
      text-align: right;
    }

    &-item-price {
      width: 60px;
      margin: 0px 4px;
      text-align: right;
    }

    &-item-tp {
      width: 60px;
      margin: 0px 4px;
      text-align: right;
    }

    &-item-sl {
      width: 60px;
      margin: 0px 4px;
      text-align: right;
    }

    &-item-pl-s {
      width: 60px;
      margin: 0px 4px;
      text-align: right;
    }

    &-item-pl-per {
      width: 35px;
      margin: 0px 4px;
      text-align: right;
    }

    &-item-pl-pip {
      width: 35px;
      text-align: right;
      padding-right: 12px;
    }

    &-item-ico {
      display: flex;
      width: 24px;
      justify-content: center;

      &-info {
        i {
          font-size: 14px !important;
        }
      }

      i {
        font-size: 16px;
        line-height: 1;
        color: #718da8;

        &:hover {
          color: #cae9ff;
        }
      }

      &:last-child {
        margin-right: 8px;
      }
    }
  }
}
</style>